import SwipeableViews from "react-swipeable-views";
import styled from "styled-components";
import { getColor } from "../../../../../ui/_themes/helpers";
import {
  bottomGradient,
  topGradient
} from "../../../../../ui/_utils/styleUtils";

export const SlideContainer = styled(SwipeableViews)`
  display: flex;
  flex: 1 0 100%;
  flex-direction: row;
  > .react-swipeable-view-container {
    display: flex;
    flex: 1;
    flex-direction: column;
    & > div {
      position: sticky;
    }
  }
`;

export const BetSlideContainer = styled.div`
  width: 100%;
  flex-shrink: 0;
  overflow: auto;
  position: sticky;
`;

export const SlideTitle = styled.div`
  text-align: center;
  font-size: 0.8em;
  font-weight: 700;
  color: ${getColor("gameSettingsText", "gameSettings.text")};
  margin-bottom: 2em;
  white-space: normal;
  word-break: break-word;
`;

export const ScrollableWithGradientContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 100%;

  ${topGradient};
  ${bottomGradient};

  &:before,
  &:after {
    position: sticky;
  }
`;

export const AutoplayRoundsContainer = styled(
  ScrollableWithGradientContainer
)``;
export const AutoplaySettingsContainer = styled(
  ScrollableWithGradientContainer
)``;
